var _circle, _path, _path2, _path3, _path4, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHerdyNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.607,
    height: 53.136,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 39",
    cx: 5.838,
    cy: 5.838,
    r: 5.838,
    transform: "translate(15.93 13.766)",
    fill: "#32187c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 373",
    d: "M24.081 34.803c-.1 7-2.493 18.334-2.493 18.334-4.2-6.9-15.1-15.2-19.229-18.206a55.348 55.348 0 0121.722-.128z",
    fill: "#b1a6ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 374",
    d: "M18.65 25.838v8.172s1.93 3.543 0 3.925c-4.243.85-10.373-3.919-10.373-3.919V21.539z",
    fill: "#ff505c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 375",
    d: "M21.198 7.27s3.82 7.744 4.775 14.962c.678 5.124-8.7 11.883-16.34 4.671S4.115 8.649 4.115 8.649z",
    fill: "#ff505c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 376",
    d: "M18.489.212c-2.351.456-5.682.209-7.953.675-2.8.578-5.44 1.289-7.2 3.711-2.786 3.825-2.4 11.61.527 15.782a2.667 2.667 0 001.778 2 3.128 3.128 0 004-2.014c.887-2.483-.473-5.478-.848-7.941-.089-.55-.122-1.273-.25-1.953 6.67-.094 11.914.652 15.341-4.77 3.519-5.57-2.133-6.131-5.395-5.49z",
    fill: "#32187c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 40",
    cx: 5.838,
    cy: 5.838,
    r: 5.838,
    transform: "translate(0 16.312)",
    fill: "#32187c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerdyNotification);
export default __webpack_public_path__ + "static/media/herdy-notification.a70e0ca6194ae4a2fb1f029e348f2105.svg";
export { ForwardRef as ReactComponent };